function loadSocialAidMembersSelect2 () {
  let select_field = $("[rel='social_aid_members_select2']",)

  let url = select_field.data('url') || '/social_aid/members.json?skip_create=1';

  select_field.select2({
    allowClear: true,
    placeholder: "Įrašykite nario pavadinimą",
    minimumInputLength: 2,
    multiple: false,
    width: '100%',
    language: lt,
    ajax: {
      quietMillis: 500,
      url: url,
      dataType: "json",
      data: function(term, page) {
        return {
          q: { name: term.term },
          page: page
        };
      },
      processResults: function(data) {
        return { results: data.members }
      },
      results: function(data, page) {
        return {
          results: data.members,
          more: (page * 100) < data.total
        };
      }
    },
  });

  if(!!$("[rel='social_aid_members_select2']").data('selected') && $("[rel='social_aid_members_select2']").data('selected')){
    fetchMemberSelections(select_field, "/social_aid/members.json?skip_create=1", $("[rel='social_aid_members_select2']").data('selected'))
  }
};

function fetchMemberSelections(field, url, params){
  if(params){
    var select_field = $(field);
    $.ajax({
      type: 'GET',
      url: url,
      data: {
        q: { id_eq: params }
      }
    }).then(function (data) {
      data.members.map(function(el, index){
        var option = new Option(el.text, el.id, true, true);
        select_field.append(option).trigger('change');
      });
    });
  }
}

function initializeMemberSelects(event, element){
  let defaultSelect2Opts = {
    allowClear: true,
    placeholder: 'Pasirinkite',
    width: '100%'
  };

  let member_options = $.extend(defaultSelect2Opts, {
    placeholder: 'Įrašykite pavadinimą',
    minimumInputLength: 2,
    multiple: false,
    width: 'resolve',
    tags: false,
    language: lt,
    dropdownParent: $('#members-modal'),
    ajax: {
      quietMillis: 500,
      url: "/social_aid/members.json?skip_create=1",
      dataType: "json",
      data: function(term, page) {
        return {
          q: { name: term.term },
          page_limit: 100,
          page: page
        };
      },
      processResults: function(data) {
        return { results: data.members }
      },
      results: function(data, page) {
        return {
          results: data.members,
          more: (page * 100) < data.total
        };
      }
    },
  });

  const select = $("[rel='social-aid-request-members']").select2(member_options);

  function populateCurrentValues(memberId) {
    if (!memberId) { return; }
    if (isNaN(Number(memberId))) {
      $.ajax({
        type: 'GET',
        url: '/social_aid/members.json?skip_create=1',
        dataType: 'json',
        data: { q: { name: memberId }, page_limit: 1, page: 1 }
      }).then(function(list) {
        const first = list && list.members && list.members[0] ? list.members[0] : null;
        const id = first && first.id ? first.id : null;
        if (id && !isNaN(Number(id))) { populateCurrentValues(id); }
      });
      return;
    }
    $("#copy-data").removeClass('hidden');
    $.ajax({
      type: 'GET',
      url: `/social_aid/members/${memberId}.json`,
      dataType: 'json'
    }).then(function(resp) {
      let attrs = null;
      if (resp && resp.data && resp.data.attributes) {
        attrs = resp.data.attributes;
      } else if (resp && resp.attributes) {
        attrs = resp.attributes;
      } else if (resp && resp.member) {
        attrs = resp.member;
      } else if (resp && resp.members && resp.members[0]) {
        attrs = resp.members[0];
      } else if (resp && (resp.name || resp.code)) {
        attrs = resp;
      }
      if (!attrs) { return; }
      const mapping = {
        name: 'name',
        code: 'code',
        phone: 'phone',
        email: 'email',
        bank: 'bank',
        bank_account: 'bank_account',
        address: 'address',
        manager_name: { key: 'manager', nested: 'name' },
        manager_phone: { key: 'manager', nested: ['phone_number', 'phone'] },
        manager_email: { key: 'manager', nested: 'email' }
      };
      const panel = $('#members-modal .panel-body');
      Object.keys(mapping).forEach(function(field){
        let value = '';
        const map = mapping[field];
        if (typeof map === 'string') {
          value = attrs[map] != null ? attrs[map] : '';
        } else if (map && typeof map === 'object') {
          const nestSrc = attrs[map.key] || {};
          if (Array.isArray(map.nested)) {
            // pick the first available nested key (e.g., phone_number or phone)
            for (let i = 0; i < map.nested.length; i++) {
              const k = map.nested[i];
              if (nestSrc && nestSrc[k] != null && nestSrc[k] !== '') {
                value = nestSrc[k];
                break;
              }
            }
          } else {
            value = nestSrc ? (nestSrc[map.nested] != null ? nestSrc[map.nested] : '') : '';
          }
        }
        if (value && typeof value === 'object') {
          value = value.name || value.text || value.value || '';
        }
        const cell = panel.find(`td.${field}`);
        if (cell.length) { cell.text(value); }
      });
    });
  }

  select.on('change', function(e) {
    populateCurrentValues($(this).val());
  });

  select.on('select2:select', function(e) {
    const data = e.params && e.params.data ? e.params.data : null;
    const id = data && data.id ? data.id : $(this).val();
    populateCurrentValues(id);
  });
}

function loadSocialAidRequestsSelect2 () {
  let select_field = $("[rel='social_aid_requests_select2']",)

  let url = select_field.data('url') || '/social_aid/social_aid_requests.json?skip_create=1';

  select_field.select2({
    allowClear: true,
    placeholder: "Įrašykite nario pavadinimą",
    minimumInputLength: 2,
    multiple: false,
    width: '100%',
    language: lt,
    ajax: {
      quietMillis: 500,
      url: url,
      dataType: "json",
      data: function(term, page) {
        return {
          q: { name: term.term },
          page: page
        };
      },
      processResults: function(data) {
        return { results: data.social_aid_requests }
      },
      results: function(data, page) {
        return {
          results: data.social_aid_requests,
          more: (page * 100) < data.total
        };
      }
    },
  });

  if(!!$("[rel='social_aid_requests_select2']").data('selected') && $("[rel='social_aid_requests_select2']").data('selected')){
    fetchSocialAidRequestSelections(select_field, "/social_aid/social_aid_requests.json?skip_create=1", $("[rel='social_aid_requests_select2']").data('selected'))
  }
};

function fetchSocialAidRequestSelections(select_field, url, selectedIds) {
  if(selectedIds){
    var ids = Array.isArray(selectedIds) ? selectedIds : [selectedIds];
    $.get(url, { ids: ids.join(',') }, function(data) {
      if (data.social_aid_requests && data.social_aid_requests.length > 0) {
        data.social_aid_requests.map(function(el, index){
          var option = new Option(el.text, el.id, true, true);
          select_field.append(option).trigger('change');
        });
      }
    });
  }
}


function initializeTotalsCalculation() {
  function formatCurrency(value) {
    return new Intl.NumberFormat('lt-LT', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value) + ' EUR';
  }

  function updateIntegrationsTotals() {
    let total = 0;
    document.querySelectorAll('.quantity-input').forEach(input => {
      const value = parseFloat(input.value) || 0;
      total += value;
    });
    const totalElement = document.getElementById('integrations-total-quantity');
    if (totalElement) {
      totalElement.textContent = total;
    }
  }

  function updateCostsTotals() {
    let totalRequired = 0;
    let totalAsk = 0;
    
    document.querySelectorAll('.required-amount-input').forEach(input => {
      const value = parseFloat(input.value) || 0;
      totalRequired += value;
    });
    
    document.querySelectorAll('.ask-amount-input').forEach(input => {
      const value = parseFloat(input.value) || 0;
      totalAsk += value;
    });
    
    const totalRequiredElement = document.getElementById('costs-total-required');
    const totalAskElement = document.getElementById('costs-total-ask');
    
    if (totalRequiredElement) {
      totalRequiredElement.textContent = formatCurrency(totalRequired);
    }
    if (totalAskElement) {
      totalAskElement.textContent = formatCurrency(totalAsk);
    }
  }

  // Use event delegation for integrations form
  const integrationsForm = document.getElementById('social-aid-integrations-form');
  if (integrationsForm) {
    integrationsForm.addEventListener('input', function(e) {
      if (e.target.classList.contains('quantity-input')) {
        updateIntegrationsTotals();
      }
    });

    integrationsForm.addEventListener('cocoon:after-insert', function() {
      updateIntegrationsTotals();
    });

    integrationsForm.addEventListener('cocoon:after-remove', function() {
      updateIntegrationsTotals();
    });
  }

  // Use event delegation for costs form
  const costsForm = document.getElementById('social-aid-costs-form');
  if (costsForm) {
    costsForm.addEventListener('input', function(e) {
      if (e.target.classList.contains('required-amount-input') || 
          e.target.classList.contains('ask-amount-input')) {
        updateCostsTotals();
      }
    });

    costsForm.addEventListener('cocoon:after-insert', function() {
      updateCostsTotals();
    });

    costsForm.addEventListener('cocoon:after-remove', function() {
      updateCostsTotals();
    });
  }

  // Initial calculation
  updateIntegrationsTotals();
  updateCostsTotals();
}

$(function() {
  loadSocialAidMembersSelect2();
  loadSocialAidRequestsSelect2();
  initializeTotalsCalculation();

  $('.select2-input').select2({
    width: '100%'
  });

  $('#members-modal').on('shown.bs.modal', function (e) {
    initializeMemberSelects(e, this);
  });

  const selectAllCheckbox = document.querySelector('.select-all');
  const itemCheckboxes = document.querySelectorAll('.item-checkbox');
  const exportButton = document.querySelector('.export-button');
  const exportForm = document.getElementById('export-form');
  
  if (!selectAllCheckbox || !exportButton || !exportForm) return;
  
  function updateExportButtonState() {
    const checkedBoxes = document.querySelectorAll('.item-checkbox:checked');
    exportButton.disabled = checkedBoxes.length === 0;
    
    if (checkedBoxes.length > 0) {
      const exportText = exportButton.getAttribute('data-export-text') || 'Eksportuoti';
      exportButton.innerHTML = `${exportText} ${checkedBoxes.length} įrašus`;
    } else {
      const exportText = exportButton.getAttribute('data-export-text') || 'Eksportuoti';
      exportButton.innerHTML = `${exportText} 0 įrašų`;
    }
  }
  
  if (selectAllCheckbox) {
    selectAllCheckbox.addEventListener('change', function() {
      itemCheckboxes.forEach(checkbox => {
        checkbox.checked = selectAllCheckbox.checked;
      });
      updateExportButtonState();
    });
  }
  
  itemCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function() {
      if (!checkbox.checked && selectAllCheckbox.checked) {
        selectAllCheckbox.checked = false;
      }
      
      if (document.querySelectorAll('.item-checkbox:not(:checked)').length === 0) {
        selectAllCheckbox.checked = true;
      }
      
      updateExportButtonState();
    });
  });
  
  if (exportButton) {
    exportButton.addEventListener('click', function() {
      if (document.querySelectorAll('.item-checkbox:checked').length > 0) {
        exportForm.submit();
      }
    });
  }
});
